
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1wtbv_149",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1wtbv_153",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1wtbv_153",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1wtbv_197",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1wtbv_197",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1wtbv_200",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1wtbv_200",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1wtbv_203",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1wtbv_203",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1wtbv_203",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1wtbv_203",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1wtbv_206",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1wtbv_206",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1wtbv_206",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1wtbv_206",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_1wtbv_210",
  "body": "awsui_body_xjuzf_1wtbv_225",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1wtbv_261",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_1wtbv_264",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1wtbv_269",
  "dismiss": "awsui_dismiss_xjuzf_1wtbv_274",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1wtbv_282",
  "header-row": "awsui_header-row_xjuzf_1wtbv_286",
  "header": "awsui_header_xjuzf_1wtbv_286",
  "content": "awsui_content_xjuzf_1wtbv_315",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1wtbv_324",
  "container": "awsui_container_xjuzf_1wtbv_336",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1wtbv_347",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1wtbv_347",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1wtbv_347",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1wtbv_352",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1wtbv_352",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1wtbv_352",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1wtbv_357",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1wtbv_357",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1wtbv_362",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1wtbv_362",
  "container-body": "awsui_container-body_xjuzf_1wtbv_368",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_1wtbv_408",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_1wtbv_413",
  "fixed-width": "awsui_fixed-width_xjuzf_1wtbv_416",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_1wtbv_420",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_1wtbv_427",
  "container-arrow": "awsui_container-arrow_xjuzf_1wtbv_347",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1wtbv_477",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1wtbv_1",
  "refresh": "awsui_refresh_xjuzf_1wtbv_535",
  "root": "awsui_root_xjuzf_1wtbv_557",
  "no-wrap": "awsui_no-wrap_xjuzf_1wtbv_589",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_1wtbv_592",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_1wtbv_592",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1wtbv_592",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_1wtbv_614",
  "trigger": "awsui_trigger_xjuzf_1wtbv_592",
  "in-inline-token": "awsui_in-inline-token_xjuzf_1wtbv_656",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_1wtbv_704",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_1wtbv_708",
  "hover-area": "awsui_hover-area_xjuzf_1wtbv_712"
};
  